import { Router } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
import * as store from 'store';
import { AuthService } from '../auth/auth.service';

const MINUTES_UNIT_AUTO_LOGOUT = 5 // in Minutes
const CHECK_INTERVAL = 1000 // in ms
const STORE_KEY = 'lastAction';

@Injectable()
export class AutoLogoutService {

    constructor(
        private auth: AuthService,
        private router: Router,
        private ngZone: NgZone
    ) {
        this.check();
        this.initListener();
        this.initInterval();
    }

    get lastAction() {
        return parseInt(store.get(STORE_KEY));
    }
    set lastAction(value) {
        store.set(STORE_KEY, value);
    }

    initListener() {
        this.ngZone.runOutsideAngular(() => {
            document.body.addEventListener('click', () => this.reset());
        });
    }

    initInterval() {
        this.ngZone.runOutsideAngular(() => {
            setInterval(() => {
                this.check();
            }, CHECK_INTERVAL);
        })
    }

    reset() {
        this.lastAction = Date.now();
    }

    check() {
        const now = Date.now();
        const timeLeft = this.lastAction + MINUTES_UNIT_AUTO_LOGOUT * 60 * 1000;
        const diff = timeLeft - now;
        const isTimeout = diff < 0;

        this.ngZone.run(() => {
            if (isTimeout && this.auth.isLoggedIn) {
                this.auth.signOut().then(() => {
                    this.router.navigate(['login']);
                });
            }
        });
    }
}